'use client'

import {Box, Link, List, ListItem} from "@mui/material";
import {faBookOpenReader, faCircle} from "@fortawesome/pro-duotone-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import StyledDivider from "@/src/components/common/styled-divider/styled-divider";
import type {ArticleUrlProps} from "@/src/_types/Article/article-sidebar";
import NextLink from 'next/link';
import CitationData from "@/src/_types/Article/article-citation-data";

const ArticleCitedBy = ({
                            articleUrl,
                            hasScopus,
                            citation
                        }: {
    articleUrl: ArticleUrlProps;
    hasScopus: boolean;
    citation: CitationData[]
}) => {
    return (
        <Box mb={1}>
            <StyledDivider label="Cited by" icon={faBookOpenReader}/>
            <List sx={{py: 0}}>
                {hasScopus && citation.find((article: CitationData) => article.service === 'scopus') && (
                    <ListItem sx={{py: 0}}>
                        <Link
                            component={NextLink}
                            href={citation.find((article: CitationData) => article.service === 'scopus')?.data?.resultLink ?? '#'}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                textDecoration: 'none'
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faCircle}
                                fontSize={5}
                                style={{marginRight: 5}}
                            />
                            <SpanTypography>
                                Scopus {citation.find((article: CitationData) => article.service === 'scopus')?.count ? `(${citation.find((article: CitationData) => article.service === 'scopus')?.count})` : ''}
                            </SpanTypography>
                        </Link>
                    </ListItem>
                )}
                <ListItem sx={{py: 0}}>
                    <Link
                        component={NextLink}
                        href={citation && citation.find((article: CitationData) => article.service === 'crossref')?.count ? `${articleUrl.path}/crossref` : '#'}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            textDecoration: 'none'
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faCircle}
                            fontSize={5}
                            style={{marginRight: 5}}
                        />
                        <SpanTypography>
                            CrossRef {citation.find((article: CitationData) => article.service === 'crossref')?.count ? `(${citation.find((article: CitationData) => article.service === 'crossref')?.count})` : 0}
                        </SpanTypography>
                    </Link>
                </ListItem>
            </List>
        </Box>
    );
};

export default ArticleCitedBy;